import LeftNavBar from "@stadium/shared/src/components/left-nav";
import { useAuth0V2 } from "@stadium/services/auth0";
import { DASHBOARD } from "@stadium/constants";

const LeftNav = () => {
  const { isAuthenticated, isLoading } = useAuth0V2();

  return (
    <LeftNavBar isLoading={isLoading} isAuthenticated={isAuthenticated} application={DASHBOARD} />
  );
};

export default LeftNav;
